import React from 'react';
import TranslateHome from '../components/TranslateHome';
import Navigation from '../components/Navigation';

const TranslateLogsPage = () => {
  return (
    <div className="min-h-screen bg-pl_bg_light_5">
      <Navigation />
      <TranslateHome />
    </div>
  );
};

export default TranslateLogsPage; 